export const slEvents = {
  homePaylog: 'home_paylog_click',
  homeFilter: 'home_filter_click',
  homeDate: 'home_date_click',
  homeMilestone: 'home_milestone_click',
};
